import React, { HTMLAttributes, Ref, forwardRef } from 'react';
import { classNames } from 'primereact/utils';

import './Tag.scss';
import { Icon, IconProps } from '../Icon';

type TagVariant = 'grey' | 'blue' | 'rose' | 'danger';

export type TagProps = HTMLAttributes<HTMLSpanElement> & {
	min?: boolean;
	bold?: boolean;
	icon?: IconProps;
	variant?: TagVariant;
	rounded?: boolean;
};

export const Tag = forwardRef(
	(
		{
			min = false,
			bold = false,
			variant = 'blue',
			rounded = false,
			className,
			children,
			icon,
			...restProps
		}: TagProps,
		ref: Ref<HTMLSpanElement>
	) => {
		const finalClassName = classNames(
			'tag',
			`tag-variant-${variant}`,
			{ 'tag-min': min, 'font-semibold': bold, 'tag-rounded': rounded },
			className
		);
		return (
			<span ref={ref} className={finalClassName} {...restProps}>
				{icon && <Icon {...icon} />}
				{children}
			</span>
		);
	}
);
